import { useEffect, useState } from 'react';
import type { VibeCheckProposal } from '../api';
import { VibeCheck } from '../screens/VibeCheck';

/** Keep the visited advisor mounted for this tab's lifetime, without storage. */
export function VibeCheckSession({ active, onBack, onUse }: {
  active: boolean;
  onBack: () => void;
  onUse: (proposal: VibeCheckProposal) => void;
}) {
  const [visited, setVisited] = useState(active);
  useEffect(() => { if (active) setVisited(true); }, [active]);
  if (!active && !visited) return null;
  return <div className="vibe-check-session" hidden={!active}>
    <VibeCheck active={active} onBack={onBack} onUse={onUse} />
  </div>;
}
